<template>
  <!-- Logged-out: reveal/login button. (When logged in, the account + sign out
       live in the TopRightAccount hamburger.) -->
  <div class="top-right-menu" v-if="!querentId">
    <button @click="showLoginModal" class="login-button">
      <i class="fa fa-sign-in"></i> Reveal Myself
    </button>
  </div>
</template>

<script>
import { clearAuthIntent } from '@/utils/request-auth';

export default {
  props: {
    querentId: {
      type: [String, Number],
      required: true,
    },
    showHamburgerMenu: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showLogoutConfirm: false,
    };
  },
  emits: ['sign_out', 'update:showLogin'],
  methods: {
    showLoginModal() {
      // A deliberate sign-in, not a blocked action: no theme, so show the
      // general hero rather than whatever gate fired last.
      clearAuthIntent();
      this.$emit('update:showLogin', true);
    },
    confirmSignOut() {
      this.showLogoutConfirm = false;
      this.$emit('sign_out');
    },
  },
};
</script>

<style scoped>
.top-right-menu {
  position: fixed;
  top: 0;
  right: 0;
  /* Match TopRightAccount's 44px centered bar so the logout icon vertically
     aligns with the messages + account chip beside it. */
  height: 44px;
  display: flex;
  align-items: center;
  padding-right: 16px;
  background-color: transparent;
  z-index: 1000;
}

.logout-icon {
  background-color: #000;
  color: #663399;
  border: none;
  cursor: pointer;
  padding: 10px 15px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  transition: all 0.3s ease;
}
.logout-icon i {
  color: #663399;
  transition: color 0.3s ease;
}
.logout-icon:hover {
  background-color: #1a0a2e;
}
.logout-icon:hover i {
  color: #9a71bd;
}

.login-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(180deg, #7b4bb0, #4e2776);
  color: #FFDFA3;
  border: 1px solid rgba(240, 217, 163, 0.35);
  border-radius: 999px;
  padding: 9px 18px;
  font-family: 'Cinzel', serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.login-button:hover {
  background: linear-gradient(180deg, #8a5bc4, #5a2f87);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.logout-confirm {
  position: absolute;
  right: 0;
  top: 100%;
  background-color: #1a0a2e;
  border: 1px solid #663399;
  border-radius: 8px;
  padding: 16px;
  width: 200px;
  z-index: 1001;
  text-align: center;
}
.logout-confirm p {
  color: white;
  margin: 0 0 12px;
  font-size: 14px;
}
.logout-confirm-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}
.confirm-btn {
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.confirm-btn.cancel {
  background-color: #444;
  color: white;
}
.confirm-btn.leave {
  background-color: #663399;
  color: #FFDFA3;
}

@media screen and (max-width: 1024px) {
  .top-right-menu .logout-icon {
    display: block;
  }
}
/* Phone: the fixed top-right "Reveal Myself" pill collided with the reader name.
   Make it compact + add a soft scrim behind it so it reads as an intentional
   floating CTA over the header rather than a crude overlap. */
@media screen and (max-width: 560px) {
  .top-right-menu {
    padding-right: 10px;
    background: linear-gradient(90deg, transparent, rgba(10, 0, 21, 0.72) 45%);
  }
  .login-button {
    padding: 7px 13px;
    font-size: 11px;
    gap: 5px;
  }
}
</style>
